// Generated by script, please do not edit this file.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import * as React from 'react';
import { forwardRef } from 'react';
var Sort = function(props, ref) {
    return /*#__PURE__*/ React.createElement("svg", _object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        ref: ref
    }, props), /*#__PURE__*/ React.createElement("path", {
        d: "M7.616 3.18a.5.5 0 0 1 .696-.071l.072.071 2.5 3a.5.5 0 0 1-.704.704l-.064-.064L8 4.281 5.884 6.82a.5.5 0 0 1-.63.115l-.074-.051a.5.5 0 0 1-.115-.63l.051-.074zM7.616 12.82a.5.5 0 0 0 .696.071l.072-.071 2.5-3a.5.5 0 0 0-.704-.704l-.064.064L8 11.719 5.884 9.18a.5.5 0 0 0-.63-.115l-.074.051a.5.5 0 0 0-.115.63l.051.074z"
    }));
};
var ForwardRef = /*#__PURE__*/ forwardRef(Sort);
export default ForwardRef;
